import { Box, Button, Grid, Switch, TextField, styled } from "@mui/material";

export const StyledLeftComponentContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  bgcolor: "white",
  paddingBottom: "20px",
});

export const StyledLeftPage = styled(Grid)({
  padding: "20px",
  display: "flex",
  alignItems: "space-between",
});

export const StyledChip = styled(Button)(({ mode }: { mode?: "dark" }) => {
  if (mode === "dark") {
    return {
      borderColor: "white",
      color: "white",
      borderRadius: "20px",
      textTransform: "none",
      height: "24px",
    };
  }
  return {
    borderColor: "#002035",
    color: "#002035",
    borderRadius: "20px",
    textTransform: "none",
    height: "24px",
  };
});

export const StyledRightPage = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#002035",
  padding: "60px",
});

export const StyledSubscribeBox = styled(Box)({
  padding: "20px",
  backgroundColor: "transparent",
  width: "100%",
  marginBottom: 4,
  borderRadius: 2,
});

export const StyledSwitches = styled(Switch)({
  "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
    color: "white",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#fc4c4c",
    height: "22px",
    position: "relative",
    top: "-4px",
    right: "12%",
    borderRadius: "12px",
    opacity: 1,
    minWidth: "42px",
  },
});

export const StyledSubscribeButton = styled(Button)({
  backgroundColor: "#fc4c4c",
  color: "white",
  textTransform: "none",
  borderRadius: 2,
  padding: "10px 20px",
  width: "100%",
  "&:hover": {
    backgroundColor: "#FEDBDB",
    color: "#fc4c4c",
  },
  "&:focus": {
    backgroundColor: "##FFF6F6",
  },
});

export const StyledToggleDescription = styled("span")({
  color: "#324e61",
  fontFamily: "Roobert",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "16px",
  alignSelf: "center",
});

export const StyledEmailField = styled(TextField)({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "4px",
  borderRadius: "10px",
  background: "#fff",
  boxShadow: "0px 4px 20px 0px #ADC0CB4D",
});

export const StyledEndAddorment = styled(Button)(({ theme }) => ({
  display: "flex",
  padding: "14px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "0px 10px 10px 10px",
  background: "#fc4c4c",
  boxShadow: "0px 4px 24px 0px rgba(255, 57, 57, 0.24)",
  color: "#fff",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "22px",
  textTransform: "none",
  "&:hover": {
    background: "#ff0000", // Change the background color on hover
    color: "#ffffff", // Change the text color on hover
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
